/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 13.10.2016.
 */

import _get from 'lodash/get';

export const INIT_PURCHASE = 'init-purchase';
export const ACK_PURCHASE = 'ack-purchase';
export const STRIPE_PROCESS = 'stripe-process';
export const CANCEL_PURCHASE = 'cancel-purchase-by-user';
export const CLEAR_PAYMENT = 'clear-payment-progress';
export const GET_PURCHASES = 'get-purchases';
export const GET_SUBSCRIPTION = 'get-subscriptions';

export function GetPurchases() {
  let Q = lh.purchases.getPurchases({
    filters: [lh.models.purchase.accessor.active.true()]
  });

  return {
    type: GET_PURCHASES,
    payload: Q.then(function (collection) {

      return collection.filter(function (el) {

        return el.offer && el.offer.type !== 'subscription';
      });
    })
  };
}

export function GetSubscriptions() {
  let Q = lh.purchases.getPurchases({
    filters: [lh.models.purchase.accessor.active.true()]
  });

  return {
    type: GET_SUBSCRIPTION,
    payload: Q.then(function (collection) {

      return collection.filter(function (el) {

        return el.offer && el.offer.type === 'subscription';
      });
    })
  };
}

export function InitiatePurchase(assetId, offerId, dialogId) {

  return {
    type: INIT_PURCHASE,
    meta: {
      asset: dialogId
    },
    payload: lh.purchases.initiatePurchase(offerId, assetId)
      .then((response) => {

        return response;
      }, (reason) => {

        if (reason.message === 'pending purchase exists') {

          return lh.purchases.cancelPurchase(reason.tx_id)
            .then(()=> {

              return InitiatePurchase(assetId, offerId, dialogId).payload
            });
        } else {

          console.warn('init purchase fail: ', reason);
          return Promise.reject(reason);
        }
      })
  };
}

export function StripeProcess(dialogId, tx) {

  let defer = new Promise((resolve, reject) => {

    let ackRequest = _get(tx, 'ack_request', {});

    if (window.StripeCheckout) {

      var handler = StripeCheckout.configure({
        allowRememberMe: false,
        key: ackRequest.key,
        image: Config.logo.img_url,
        token: function (token) {

          if (token) {

            resolve(token);
          } else {

            reject(token);
          }
        },
        closed: function () {

          reject({
            result: 0,
            message: 'Canceled by user'
          });
        }
      });

      var settings = {
        description: ackRequest.description,
        amount: ackRequest.amount
      };

      if (ackRequest.label === 'Subscribe') {
        settings.panelLabel = ackRequest['panel-label'];
      }

      handler.open(settings);

    } else {

      reject({
        result: 0,
        message: 'Stripe connection error'
      });
    }

  });

  return {
    type: STRIPE_PROCESS,
    meta: {
      asset: dialogId,
    },
    payload: defer
  }
}

export function AcknowledgePurchase(dialogId, txId, confirmationCode) {

  return {
    type: ACK_PURCHASE,
    meta: {
      asset: dialogId,
    },
    payload: lh.purchases.acknowledgePurchase(txId, confirmationCode)
  };
}

export function CancelSubscription(subscriptionId, dialogId) {

  return {
    type: CANCEL_PURCHASE,
    meta: {
      asset: dialogId
    },
    payload: lh.purchases.cancelSubscription(subscriptionId)
  };
}

export function ClearPayment(assetId) {

  return {
    type: CLEAR_PAYMENT,
    meta: {
      asset: assetId,
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/purchase/actions-purchase.js